import { useState } from "react";
import { db } from "./firebase";
import { collection, addDoc } from "firebase/firestore";
import { inputStyle, btnStyle, cardStyle, labelStyle, colors } from "./lib/theme";

var textareaStyle = { ...inputStyle, minHeight: 110, resize: "vertical", fontFamily: "inherit" };

export default function ContactPage({ user }) {
  var [name, setName] = useState(user ? user.displayName : "");
  var [email, setEmail] = useState(user ? user.email : "");
  var [phone, setPhone] = useState("");
  var [message, setMessage] = useState("");
  var [error, setError] = useState("");
  var [sending, setSending] = useState(false);
  var [sent, setSent] = useState(false);

  function handleSubmit(e) {
    e.preventDefault();
    setError("");
    if (!name.trim() || !email.trim() || !phone.trim()) {
      setError("Name, email and phone number are required.");
      return;
    }
    setSending(true);
    addDoc(collection(db, "contactMessages"), {
      name: name.trim(),
      email: email.trim(),
      phone: phone.trim(),
      message: message.trim(),
      uid: user ? user.uid : null,
      handled: false,
      createdAt: new Date().toISOString(),
    })
      .then(function () { setSent(true); })
      .catch(function (err) {
        if (err.code === "permission-denied") {
          setError("The contact form isn't accepting messages yet — the Firestore rules for it haven't been published. (Firebase console → Firestore Database → Rules → publish the latest firestore.rules.)");
        } else {
          setError("Something went wrong sending your message (" + err.code + "). Please try again.");
        }
      })
      .finally(function () { setSending(false); });
  }

  if (sent) {
    return (
      <div style={cardStyle}>
        <h2 style={{ marginTop: 0, fontSize: 18 }}>Thanks!</h2>
        <p style={{ fontSize: 14, color: colors.text }}>Your message has been sent — we'll get back to you as soon as possible.</p>
      </div>
    );
  }

  return (
    <div>
      <h2 style={{ fontSize: 18, marginBottom: 4 }}>Contact Form</h2>
      <p style={{ fontSize: 13, color: colors.textDim, marginTop: 0, marginBottom: 20 }}>
        If you wish to contact us, please use the form below and we will get back to you as soon as possible.
        Required fields are marked *
      </p>

      <form onSubmit={handleSubmit} style={cardStyle}>
        {error && <div style={{ background: colors.dangerBg, border: "1px solid " + colors.dangerBorder, borderRadius: 8, padding: "10px 14px", fontSize: 13, color: colors.danger, marginBottom: 16 }}>{error}</div>}

        <div style={{ marginBottom: 14 }}>
          <div style={labelStyle}>Your Name *</div>
          <input style={inputStyle} value={name} onChange={function (e) { setName(e.target.value); }} required />
        </div>
        <div style={{ marginBottom: 14 }}>
          <div style={labelStyle}>Your E-mail *</div>
          <input style={inputStyle} type="email" value={email} onChange={function (e) { setEmail(e.target.value); }} required />
        </div>
        <div style={{ marginBottom: 14 }}>
          <div style={labelStyle}>Phone Number *</div>
          <input style={inputStyle} type="tel" value={phone} onChange={function (e) { setPhone(e.target.value); }} required />
        </div>
        <div style={{ marginBottom: 20 }}>
          <div style={labelStyle}>Your Message</div>
          <textarea style={textareaStyle} value={message} onChange={function (e) { setMessage(e.target.value); }} />
        </div>

        <button type="submit" style={btnStyle} disabled={sending}>{sending ? "Sending..." : "Send Message"}</button>
      </form>
    </div>
  );
}
